// The message behind a failed request. A 422 from quant-data carries `detail` as a list
// of pydantic errors, an HTTPException carries it as a plain string, and a guard that
// refused before reaching the API throws a plain Error.
export const apiErrorMessage = (error: any, fallback: string): string => {
  const detail = error?.data?.detail;
  if (Array.isArray(detail) && detail[0]?.msg) return detail[0].msg;
  if (typeof detail === 'string' && detail) return detail;
  if (error instanceof Error && error.message) return error.message;
  return fallback;
};
